import React from 'react';
import {NavLink} from "react-router-dom";
import GenerateURL from "../../utils/generateURL";
import {CONTACTS_ROUTE, GAMES_ROUTE, INDEX_ROUTE} from "../../utils/consts";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import {ScrollToPositionFixed} from "../../utils/ScrollToPositionFixed";

const Menu = ({setMobileMenu}) => {
    const {t} = useTranslation();

    return (
        <ul className="menu">
            <li>
                <NavLink
                    to={GenerateURL(INDEX_ROUTE)}
                    exact
                    onClick={() => {
                        if (document.body.clientWidth <= 1280) {
                            ScrollToPositionFixed(true);
                            setMobileMenu(false);
                        }
                    }}
                >{t('Home')}
                </NavLink>
            </li>
            <li>
                <NavLink
                    to={GenerateURL(GAMES_ROUTE)}
                    exact
                    className={(/^\/[a-z]{2}\/game\/(?:([^]+?))\/?$/i.test(window.location.pathname) && document.querySelector('.details')) ? 'active' : ''}
                    onClick={() => {
                        if (document.body.clientWidth <= 1280) {
                            ScrollToPositionFixed(true);
                            setMobileMenu(false);
                        }
                    }}
                >{t('GAMES')}
                </NavLink>
            </li>
            <li>
                <NavLink
                    to={GenerateURL(CONTACTS_ROUTE)}
                    exact
                    className="border_link"
                    onClick={() => {
                        if (document.body.clientWidth <= 1280) {
                            ScrollToPositionFixed(true);
                            setMobileMenu(false);
                        }
                    }}
                >{t('Support & Contact')}
                </NavLink>
            </li>
        </ul>
    );
};

export default observer(Menu);